const searchActionTypes =  {        
    RETRIEVED_SITESETTINGS_BASIC_SEARCH_SETTINGS: "RETRIEVED_SITESETTINGS_BASIC_SEARCH_SETTINGS",
    SITESETTINGS_BASIC_SEARCH_SETTINS_CLIENT_MODIFIED: "SITESETTINGS_BASIC_SEARCH_SETTINS_CLIENT_MODIFIED",
    UPDATED_SITESETTINGS_BASIC_SEARCH_SETTINGS: "UPDATED_SITESETTINGS_BASIC_SEARCH_SETTINGS",
    RETRIEVED_SITESETTINGS_SYNONYMS_GROUPS: "RETRIEVED_SITESETTINGS_SYNONYMS_GROUPS",
    CREATED_SITESETTINGS_SYNONYMS_GROUP: "CREATED_SITESETTINGS_SYNONYMS_GROUP",
    UPDATED_SITESETTINGS_SYNONYMS_GROUP: "UPDATED_SITESETTINGS_SYNONYMS_GROUP",
    DELETED_SITESETTINGS_SYNONYMS_GROUP: "DELETED_SITESETTINGS_SYNONYMS_GROUP",
    SITESETTINGS_SYNONYMS_GROUP_CLIENT_MODIFIED: "SITESETTINGS_SYNONYMS_GROUP_CLIENT_MODIFIED",
    CANCELED_SITESETTINGS_SYNONYMS_GROUP_CLIENT_MODIFIED: "CANCELED_SITESETTINGS_SYNONYMS_GROUP_CLIENT_MODIFIED",
    RETRIEVED_SITESETTINGS_IGNORE_WORDS: "RETRIEVED_SITESETTINGS_IGNORE_WORDS",
    SITESETTINGS_IGNORE_WORDS_CLIENT_MODIFIED: "SITESETTINGS_IGNORE_WORDS_CLIENT_MODIFIED",
    CANCELED_SITESETTINGS_IGNORE_WORDS_CLIENT_MODIFIED: "CANCELED_SITESETTINGS_IGNORE_WORDS_CLIENT_MODIFIED",
    CREATED_SITESETTINGS_IGNORE_WORDS: "CREATED_SITESETTINGS_IGNORE_WORDS",
    UPDATED_SITESETTINGS_IGNORE_WORDS: "UPDATED_SITESETTINGS_IGNORE_WORDS",
    DELETED_SITESETTINGS_IGNORE_WORDS: "DELETED_SITESETTINGS_IGNORE_WORDS",
    RETRIEVED_SITESETTINGS_SEARCH_CULTURE_LIST: "RETRIEVED_SITESETTINGS_SEARCH_CULTURE_LIST"    
};
export default searchActionTypes;
